<template>
    <v-dialog 
        v-model="$store.getters.overlays.siteRegulation" 
        :max-width="$language() === 'en' ? 650 : 1000"
        :fullscreen="$language() === 'en' ? $store.getters.window.width<=800 : $store.getters.window.width<=900"
        persistent
        content-class="loginViewDialog"
        >
        
        <v-card>
            <v-card-title :class="$style.loginViewWrapper">
                <v-spacer/>
                    <img :src="VivomapLogo"/>
                <v-spacer/>

                <v-icon @click="$store.dispatch('siteRegulation',false);" color="black" :class="$style.loginCloseBtn">fa-times-circle</v-icon>
            </v-card-title>        

            <SiteRegulation />
        </v-card>        
    </v-dialog>


</template>

<script>
import VivomapLogo from '@/assets/images/logos/vivomap.png';
import SiteRegulation from '@/components/SiteRegulation/SiteRegulation.vue';


export default {
    name: "SiteRegulationContainer",
    components: {
        SiteRegulation
    },
    data: function(){
        return {
            tab: null
        }
    },
    methods: { },
    computed: {
        VivomapLogo: function(){
            return VivomapLogo;
        }
    }
}
</script>

<style module>
.loginViewWrapper img{
    max-height: 100px;
    margin-top:4%;
}

.loginViewWrapper {
    position: relative;
}
    .loginCloseBtn {
        position: absolute;
        right: 4.5%;
        top: 15%;
    }

.loginTab, .registerTab {
    font-size: 17pt !important;
    font-weight: 400 ;
    text-transform: initial !important;
}

.loginSlider {
    margin-top: 10px;
}


</style>

<style>
.v-tabs-bar__content{
    max-width: 200px;
    margin: auto;
}

.loginViewDialog {
    border-radius: 25px !important;
}
</style>